import { render, staticRenderFns } from "./Inspeccion.vue?vue&type=template&id=c52aa79e&scoped=true&"
import script from "./Inspeccion.vue?vue&type=script&lang=js&"
export * from "./Inspeccion.vue?vue&type=script&lang=js&"
import style0 from "./Inspeccion.vue?vue&type=style&index=0&id=c52aa79e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c52aa79e",
  null
  
)

export default component.exports